import { ApolloClient } from '@apollo/client/core'
import { loadDevMessages } from '@apollo/client/dev'
import { ApolloClients, provideApolloClients } from '@vue/apollo-composable'
import { getClientOptions } from 'src/apollo'
import { APOLLO_CLIENTS } from 'src/common/dictionary'
import { $apollo } from '@/apollo/apollo-options-api.js'

export default (ctx) => {
  const { app } = ctx
  const options = getClientOptions()
  const optionsGo = getClientOptions(true)
  const apolloClient = new ApolloClient(options)
  const apolloClientGo = new ApolloClient(optionsGo)

  const apolloClients = {
    [APOLLO_CLIENTS.default]: apolloClient,
    [APOLLO_CLIENTS.clientGo]: apolloClientGo,
  }

  provideApolloClients(apolloClients)
  app.provide(ApolloClients, apolloClients)
  app.config.globalProperties.$apollo = $apollo

  if (process.env.NODE_ENV === 'development') {
    loadDevMessages()
  }
}
